// Author Liang Gangqiang
// Date 2022-07-04 11:54:35

import * as model from "@/model/sithMes/rita/SithMesRitaTestTaskModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";
import {customVuexEntityPatternFactory} from "@/store/em/commonPattern/customVuexEntityPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesRitaTestTask(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_RITA_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'managerFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'customerFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'managerEntity',
        entityConstructor: model.SithMesRitaTestTask
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'managerVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'customerVo'
    })
    .buildStore()
